import { createSelector } from 'reselect';

const selectPreferencesRoot = (state) => state.preferences;

export const selectTheme = createSelector(
    [selectPreferencesRoot],
    (p) => p.theme
);

export const selectSidebarCollapsed = createSelector(
    [selectPreferencesRoot],
    (p) => p.sidebarCollapsed
);

export const selectSystemIsDark = createSelector(
    [selectPreferencesRoot],
    (p) => p.systemIsDark
);

export const selectPreferencesIsInitialized = createSelector(
    [selectPreferencesRoot],
    (p) => p.isInitialized
);

export const selectLanguage = createSelector(
    [selectPreferencesRoot],
    (p) => p.language
);

export const selectTimezone = createSelector(
    [selectPreferencesRoot],
    (p) => p.timezone
);

export const selectNotificationsDiagramShared = createSelector(
    [selectPreferencesRoot],
    (p) => p.notificationsDiagramShared
);

export const selectNotificationsMentions = createSelector(
    [selectPreferencesRoot],
    (p) => p.notificationsMentions
);

export const selectNotificationsProductUpdates = createSelector(
    [selectPreferencesRoot],
    (p) => p.notificationsProductUpdates
);

// Wire-shaped diagram object (snake_case keys) — rows read individual keys.
// (Named `diagram`, not `editor` — "editor" is reserved for the upcoming code
// editor's own preference group.)
export const selectDiagramPrefs = createSelector(
    [selectPreferencesRoot],
    (p) => p.diagram
);

// input_mode 'auto' (the default) currently behaves as 'trackpad' — the
// previous default. Real input-device detection can replace this resolution
// in one place later (a wheel-heuristic version was built and removed for
// now — see git history / project memory if it comes back). Behavior
// consumers (canvas wheel handling, scrollbars) resolve through this; option
// pickers show the raw stored value.
export const resolveInputMode = (inputMode) =>
    (inputMode === 'auto' || inputMode == null) ? 'trackpad' : inputMode;

// Pure: depends only on stored theme + cached system preference.
// Returns 'light' or 'dark' — never 'system'.
export const selectResolvedTheme = createSelector(
    [selectTheme, selectSystemIsDark],
    (theme, systemIsDark) => {
        if (theme === 'system') return systemIsDark ? 'dark' : 'light';
        return theme;
    }
);
